import React, { useEffect, useState } from "react";
import { apiPath, TransportCategories } from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import LoaderFilling from "../../components/shared/Loader/LoaderFilling";
import { useParams } from "react-router-dom";
import CustomMultiInputForm from "../../components/globalForm/CustomMultiInputForm";
import useSession from "../../hooks/useSession";

function LocalTransportUniquePage() {
  const { localApi } = apiPath;
  let { id } = useParams();
  const [apiData, apiDataLoading] = useFetch(`${localApi}/${id}`);
  const [user] = useSession();

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  const {
    busName,
    busNameBn,
    category,
    city,
    duration,
    fair,
    fairBn,
    image,
    durationBn,
    info,
    infoBn,
    priceChart,
    stoppage,
    _id,
    updatedAt,
    createdBy,
    updatedBy,
  } = apiData ?? {};

  // Form data
  const data = [
    {
      elementType: "file",
      label: "Transport image",
      type: "Text",
      name: "image",
      required: false,
      //   defaultValue: image?.url ? image : placeholder,
      defaultValue: image?.url,
      fullCol: true,
      fullHeight: true,
    },
    {
      elementType: "file",
      label: "Price Chart image",
      type: "Text",
      defaultValue: priceChart,
      name: "priceChart",
      required: false,
      fullCol: true,
      fullHeight: true,
    },
    {
      elementType: "select",
      label: "City Name",
      type: "Text",
      name: "city",
      required: true,
      options: [
        "dhaka",
        "chattogram",
        "barishal",
        "khulna",
        "mymensingh",
        "rangpur",
        "sylhet",
        "rajshahi",
      ],
      defaultValue: city,
    },
    {
      elementType: "textField",
      label: "Transport Name",
      type: "Text",
      defaultValue: busName,
      name: "busName",
      required: true,
    },
    {
      elementType: "textField",
      label: "Transport Name - Bangla",
      type: "Text",
      defaultValue: busNameBn,
      name: "busNameBn",
      required: true,
    },
    {
      elementType: "select",
      label: "Transport category",
      type: "Text",
      name: "category",
      required: true,
      options: TransportCategories,
      defaultValue: category,
    },
    {
      elementType: "input",
      label: "Estimated duration",
      type: "Text",
      name: "duration",
      defaultValue: duration,
      required: false,
      fullCol: true,
    },
    {
      elementType: "input",
      label: "Estimated duration - Bangla",
      type: "Text",
      defaultValue: durationBn,
      name: "durationBn",
      required: false,
      fullCol: true,
    },
    {
      elementType: "input",
      label: "transport fare",
      defaultValue: fair,
      type: "Text",
      name: "fair",
      required: false,
      fullCol: true,
    },
    {
      elementType: "input",
      label: "transport fare - Bangla (৳)",
      defaultValue: fairBn,
      type: "Text",
      name: "fairBn",
      required: false,
      fullCol: true,
    },
    {
      elementType: "textField",
      label: "Extra Information",
      type: "Text",
      defaultValue: info,
      name: "info",
      required: false,
      fullCol: true,
    },
    {
      elementType: "textField",
      label: "Extra Information - Bangla",
      type: "Text",
      defaultValue: infoBn,
      name: "infoBn",
      required: false,
      fullCol: true,
    },
  ];

  const update = (data) => {
    let newData = { ...data };
    newData.image = {
      url: data.image,
      name: data.busName,
    };

    // price chart
    if (data?.priceChart?.length > 0) {
      newData.priceChart = {
        url: data.priceChart,
      };
    } else {
      newData.priceChart = {
        url: "",
      };
    }

    // check for empty values
    if (!data?.info) {
      newData.info = "";
    }
    if (!data?.infoBn) {
      newData.infoBn = "";
    }

    // api call
    updateData(localApi, newData, id);
  };

  function updateMultiple(formFields, name) {
    const data = { stoppage: formFields };
    console.log(data);
    updateData(localApi, data, id);
  }

  return (
    <div>
      {/* Logs */}
      {user.role === "admin" && (createdBy || updatedBy || updatedAt) && (
        <div className="p-4 sm:px-8">
          <div className="border text-gray-700 dark:text-gray-400 border-gray-400 dark:border-gray-600 border-dashed rounded-lg px-4 py-6">
            {/* created by */}
            {createdBy && (
              <div>
                <span className="font-medium">Created By: </span>
                <span>{createdBy}</span>
              </div>
            )}
            {/* updated by */}
            {updatedBy && (
              <div>
                <span className="font-medium">Updated By: </span>
                <span>{updatedBy}</span>
              </div>
            )}
            {/* updated at */}
            {updatedAt && (
              <div>
                <span className="font-medium">Updated At: </span>
                <span>
                  {new Intl.DateTimeFormat(["ban", "id"]).format(
                    new Date(updatedAt)
                  )}
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* form */}
      {_id && (
        <div className="px-4">
          <GlobalForm data={data} update={update} />
        </div>
      )}

      {/* Routes */}
      <div className="px-4 sm:px-8">
        <CustomMultiInputForm
          oldData={stoppage}
          pageTitle={"Routes"}
          update={updateMultiple}
          disableFormState={true}
        />
      </div>
    </div>
  );
}

export default LocalTransportUniquePage;
